import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const sliderData = [
  {
    title: "Sell your MacBook for the best value in the country. ",
    description: "Sell your MacBook for the best value in the country. Get paid upto $6179",
    urls: 'https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/1.png',
    path: "/Macbook"
  },
  {
    title: "Sell your iwatch and get paid up to $700",
    description: "Sell your iwatch and get paid up to $700",
    urls: "https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/2.png",
    path: "/iWatch"
  },
  {
    title: "Sell your iPhone today for upto $1807, Same day pickup and payments available in covered areas only.",
    description: "Sell your iPhone today for upto $1807, Same day pickup and payments available in covered areas only.",
    urls: "https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/3.png",
    path: "/iPhone"
  },
  {
    title: "Sell your iPad get paid upto $2075. Paid by Cash, E-trasfer(Interac) and PayPal..",
    description: "Sell your iPad get paid upto $2075. Paid by Cash, E-trasfer(Interac) and PayPal.",
    urls: "https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/4.png",
    path: "/iPad"
  },
  {
    title: "Sell your AirPods now and get paid upto $370",
    description: "Sell your AirPods now and get paid upto $370",
    urls: "https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/5.png",
    path: "/AirPods"
  },
  {
    title: "Sell your Apple devices for best bucks!",
    description: "Sell your Apple devices for best bucks!",
    urls: "https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/6.png",
    path: "/SellAdevice"
  },
];

const Slider = () => {
  return (
    <div style={{ maxWidth: '1200px', margin: 'auto' }}>
      <Carousel
        showThumbs={false}
        infiniteLoop
        autoPlay
        interval={4000}
        showStatus={false}
        useKeyboardArrows
      >
        {sliderData.map((slide, index) => (
          <div className=""key={index}>
            <a href={slide.path} style={{ display: 'block' }}>
              <img className="slider-img p-2"src={slide.urls} alt={slide.title} style={{ cursor: 'pointer' }} />
            </a>
            
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Slider;
